import {
  POST_NEW_PARTICIPANT,
  POST_NEW_PARTICIPANT_SUCCESS,
  POST_NEW_PARTICIPANT_FAIL,
  GET_PARTICIPANTS,
  GET_PARTICIPANTS_SUCCESS,
  GET_PARTICIPANTS_FAIL,
  GET_PARTICIPANT_DETAIL,
  GET_PARTICIPANT_DETAIL_SUCCESS,
  GET_PARTICIPANT_DETAIL_FAIL,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  POST_PARTICIPANT_DOC,
  POST_PARTICIPANT_DOC_SUCCESS,
  POST_PARTICIPANT_DOC_FAIL,
  POST_UPDATE_PARTICIPANT,
  POST_UPDATE_PARTICIPANT_SUCCESS,
  POST_UPDATE_PARTICIPANT_FAIL,
  GET_PARTICIPANT_DOC,
  GET_PARTICIPANT_DOC_FAIL,
  GET_PARTICIPANT_DOC_SUCCESS,
  UPDATE_PARTICIPANT_PIC,
  UPDATE_PARTICIPANT_PIC_FAIL,
  UPDATE_PARTICIPANT_PIC_SUCCESS,
  SHOW_HIDE_DOC,
  SHOW_HIDE_DOC_FAIL,
  SHOW_HIDE_DOC_SUCCESS,
  PARTICIPANT_CALENDER_DATA_FAIL,
  PARTICIPANT_CALENDER_DATA,
  PARTICIPANT_CALENDER_DATA_SUCCESS,
  SET_PART_STATE,
  SET_PART_STATE_SUCCESS,
  SET_PART_STATE_FAIL,
  DELETE_DOC,
  DELETE_DOC_SUCCESS,
  DELETE_DOC_FAIL,
  DELETE_DESCRIPTION,
  DELETE_DESCRIPTION_SUCCESS,
  DELETE_DESCRIPTION_FAIL,
  PARTICIPANTS_LOCATION_ASSIGNEES,
  PARTICIPANTS_LOCATION_ASSIGNEES_SUCCESS,
  PARTICIPANTS_LOCATION_ASSIGNEES_FAIL,
  PARTICIPANT_DETAILS_FOR_TASK,
  PARTICIPANT_DETAILS_FOR_TASK_SUCCESS,
  PARTICIPANT_DETAILS_FOR_TASK_FAIL,
  PARTICIPANT_STATUS_HISTORY,
  PARTICIPANT_STATUS_HISTORY_SUCCESS,
  PARTICIPANT_STATUS_HISTORY_FAIL,
  ADD_REMARK_ON_STATUS_SUCCESS,
  ADD_REMARK_ON_STATUS_FAIL,
  ADD_REMARK_ON_STATUS,
  GET_MYNDIS_GOAL,
  GET_MYNDIS_GOAL_SUCCESS,
  GET_MYNDIS_GOAL_FAIL,
} from "./actionTypes";

export const addRemarkOnStatus = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_REMARK_ON_STATUS,
  payload: { data, onSuccess, onError },
});
export const addRemarkOnStatusSuccess = data => ({
  type: ADD_REMARK_ON_STATUS_SUCCESS,
  payload: data,
});
export const addRemarkOnStatusFail = data => ({
  type: ADD_REMARK_ON_STATUS_FAIL,
  payload: data,
});

export const participantStatusHistory = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: PARTICIPANT_STATUS_HISTORY,
  payload: { data, onSuccess, onError },
});
export const participantStatusHistorySuccess = data => ({
  type: PARTICIPANT_STATUS_HISTORY_SUCCESS,
  payload: data,
});
export const participantStatusHistoryFail = data => ({
  type: PARTICIPANT_STATUS_HISTORY_FAIL,
  payload: data,
});

export const participantDetails = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: PARTICIPANT_DETAILS_FOR_TASK,
  payload: { data, onSuccess, onError },
});
export const participantDetailsSuccess = data => ({
  type: PARTICIPANT_DETAILS_FOR_TASK_SUCCESS,
  payload: data,
});
export const participantDetailsFail = data => ({
  type: PARTICIPANT_DETAILS_FOR_TASK_FAIL,
  payload: data,
});

export const participantsLocationAssignees = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: PARTICIPANTS_LOCATION_ASSIGNEES,
  payload: { data, onSuccess, onError },
});
export const participantsLocationAssigneesSuccess = data => ({
  type: PARTICIPANTS_LOCATION_ASSIGNEES_SUCCESS,
  payload: data,
});
export const participantsLocationAssigneesFail = data => ({
  type: PARTICIPANTS_LOCATION_ASSIGNEES_FAIL,
  payload: data,
});

export const deletePartDescription = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_DESCRIPTION,
  payload: { data, onSuccess, onError },
});
export const deletePartDescriptionSuccess = data => ({
  type: DELETE_DESCRIPTION_SUCCESS,
  payload: data,
});
export const deletePartDescriptionFail = data => ({
  type: DELETE_DESCRIPTION_FAIL,
  payload: data,
});

export const deletePartDocument = data => ({
  type: DELETE_DOC,
  payload: data,
});
export const deletePartDocumentSuccess = data => ({
  type: DELETE_DOC_SUCCESS,
  payload: data,
});
export const deletePartDocumentFail = data => ({
  type: DELETE_DOC_FAIL,
  payload: data,
});

export const setPartstate = (data, onSuccess = () => {}, onError = () => {}) => ({
  type: SET_PART_STATE,
  payload: { data, onSuccess, onError },
});
export const setPartstateSuccess = data => ({
  type: SET_PART_STATE_SUCCESS,
  payload: data,
});
export const setPartstateFail = data => ({
  type: SET_PART_STATE_FAIL,
  payload: data,
});

export const getPartCalData = data => ({
  type: PARTICIPANT_CALENDER_DATA,
  payload: data,
});
export const getPartCalDataSuccess = data => ({
  type: PARTICIPANT_CALENDER_DATA_SUCCESS,
  payload: data,
});
export const getPartCalDataFail = data => ({
  type: PARTICIPANT_CALENDER_DATA_FAIL,
  payload: data,
});

export const handleShowHideDoc = data => ({
  type: SHOW_HIDE_DOC,
  payload: data,
});
export const handleShowHideDocSuccess = data => ({
  type: SHOW_HIDE_DOC_SUCCESS,
  payload: data,
});
export const handleShowHideDocFail = data => ({
  type: SHOW_HIDE_DOC_FAIL,
  payload: data,
});

export const updateParticipantPic = data => ({
  type: UPDATE_PARTICIPANT_PIC,
  payload: data,
});
export const updateParticipantPicSuccess = data => ({
  type: UPDATE_PARTICIPANT_PIC_SUCCESS,
  payload: data,
});
export const updateParticipantPicFail = data => ({
  type: UPDATE_PARTICIPANT_PIC_FAIL,
  payload: data,
});

export const getPartDoc = data => ({
  type: GET_PARTICIPANT_DOC,
  payload: data,
});
export const getPartDocSuccess = data => ({
  type: GET_PARTICIPANT_DOC_SUCCESS,
  payload: data,
});
export const getPartDocFail = data => ({
  type: GET_PARTICIPANT_DOC_FAIL,
  payload: data,
});

export const postPartDoc = data => ({
  type: POST_PARTICIPANT_DOC,
  payload: { data },
});
export const postPartDocSuccess = data => ({
  type: POST_PARTICIPANT_DOC_SUCCESS,
  payload: { data },
});
export const postPartDocFail = data => ({
  type: POST_PARTICIPANT_DOC_FAIL,
  payload: { data },
});

export const postNewParticipant = user => ({
  type: POST_NEW_PARTICIPANT,
  payload: { user },
});

export const postNewParticipantSuccess = data => ({
  type: POST_NEW_PARTICIPANT_SUCCESS,
  payload: data,
});

export const postNewParticipantFail = error => ({
  type: POST_NEW_PARTICIPANT_FAIL,
  payload: error,
});
export const postUpdateParticipant = user => ({
  type: POST_UPDATE_PARTICIPANT,
  payload: user,
});

export const postUpdateParticipantSuccess = data => ({
  type: POST_UPDATE_PARTICIPANT_SUCCESS,
  payload: data,
});

export const postUpdateParticipantFail = error => ({
  type: POST_UPDATE_PARTICIPANT_FAIL,
  payload: error,
});

// GET PARTICIPANT LIST
export const getParticipants = data => ({
  type: GET_PARTICIPANTS,
  payload: data,
});

export const getParticipantsSuccess = data => ({
  type: GET_PARTICIPANTS_SUCCESS,
  payload: data,
});

export const getParticipantsFail = error => ({
  type: GET_PARTICIPANTS_FAIL,
  payload: error,
});

export const getParticipantDetail = projectId => ({
  type: GET_PARTICIPANT_DETAIL,
  projectId,
});

export const getParticipantDetailSuccess = projectDetails => ({
  type: GET_PARTICIPANT_DETAIL_SUCCESS,
  payload: projectDetails,
});

export const getParticipantDetailFail = error => ({
  type: GET_PARTICIPANT_DETAIL_FAIL,
  payload: error,
});

export const postDeleteParticipant = id => ({
  type: DELETE_USER,
  payload: { id },
});

export const postDeleteParticipantSuccess = data => ({
  type: DELETE_USER_SUCCESS,
  payload: data,
});

export const postDeleteParticipantFail = error => ({
  type: DELETE_USER_FAIL,
  payload: error,
});

export const getNdisGoal = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_MYNDIS_GOAL,
  payload: { data, onSuccess, onError },
});
export const getNdisGoalSuccess = (data = {}) => ({
  type: GET_MYNDIS_GOAL_SUCCESS,
  payload: data,
});
export const getNdisGoalFail = (data = {}) => ({
  type: GET_MYNDIS_GOAL_FAIL,
  payload: data,
});
